import moment from "moment";

export const timeDifference = ({
  startTime,
  endTime,
}: {
  startTime: Date;
  endTime: Date;
}) => {
  const start = moment(startTime);
  const end = moment(endTime);
  const duration = moment.duration(end.diff(start));
  const minutes = duration.asMinutes();
  return minutes;
};

export default timeDifference;
